// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/background-media/background-media';
import 'snippets/card-label/card-label';
import 'snippets/cart-js/ajax-add-cart';

// Styles
import './_card.scss';
import {openModal} from 'snippets/_containers/modal/modal';
import {formatMoney} from '@shopify/theme-currency';

// Configuration object
const swatchManagerConfig = {
    CARD_PRODUCT: '.card--product',
    CARD_IMAGE_WRAPPER: '.card__image-wrapper',
    CARD_PRODUCT_IMAGE: '.card__product-image',
    CARD_COLOR_OPTION: '.card__swatch--color-option',
    CARD_COLOR_SWATCHES: '.card__color-swatches',
    SELECTED_CLASS_NAME: 'selected',
    ADD_TO_CART_FORM: 'form[action="/cart/add"]',
    INPUT_VARIANT_ID: 'input[name="id"]',

    CARD_TEXT_OPTION: '.card--text-swatch',
    CARD_TEXT_SWATCHES: '.card__text-swatches',
};

class SwatchManager {
    constructor(config) {
        this.CARD_PRODUCT = config.CARD_PRODUCT;
        this.CARD_IMAGE_WRAPPER = config.CARD_IMAGE_WRAPPER;
        this.CARD_PRODUCT_IMAGE = config.CARD_PRODUCT_IMAGE;
        this.CARD_COLOR_SWATCHES = config.CARD_COLOR_SWATCHES;
        this.CARD_TEXT_SWATCHES = config.CARD_TEXT_SWATCHES;

        this.SELECTED_CLASS_NAME = config.SELECTED_CLASS_NAME;

        this.ADD_TO_CART_FORM = config.ADD_TO_CART_FORM;
        this.INPUT_VARIANT_ID = config.INPUT_VARIANT_ID;

        this.changeSwatch();
    }

    changeSwatch(swatchOption, swatchType) {
        if (swatchOption != null) {
            const productCard = swatchOption.closest(this.CARD_PRODUCT);
            const addToCartForm = productCard?.querySelector(this.ADD_TO_CART_FORM);
            const inputVariantId = addToCartForm?.querySelector(this.INPUT_VARIANT_ID) ?? productCard?.querySelector(this.INPUT_VARIANT_ID);
            const currentVariantId = swatchOption.dataset.variantId;

            // Update selected state
            if (!swatchOption.classList.contains(this.SELECTED_CLASS_NAME)) {
                const cardSwatches = swatchType === 'color' ? this.CARD_COLOR_SWATCHES : this.CARD_TEXT_SWATCHES;
                swatchOption.closest(cardSwatches)?.querySelector(`.${this.SELECTED_CLASS_NAME}`).classList.remove(this.SELECTED_CLASS_NAME);
                swatchOption.classList.add(this.SELECTED_CLASS_NAME);

                const newImageSrc = swatchOption.dataset.imageSrc;

                if (newImageSrc !== undefined) {
                    // Get additional src and srcset
                    const newDesktopMedia = swatchOption.dataset.desktopMedia;
                    const newDesktopSrcset = swatchOption.dataset.desktopSrcset;
                    const newMobileSrcset = swatchOption.dataset.mobileSrcset;
                    const newImageSrcset = swatchOption.dataset.imageSrcset;

                    const productCardImageWrapper = productCard?.querySelector(this.CARD_IMAGE_WRAPPER);
                    if(productCardImageWrapper) {
                        const productCardPicture = productCardImageWrapper.querySelector('picture');
                        const productCardPictureImage = productCardPicture?.querySelector(this.CARD_PRODUCT_IMAGE);

                        // Update desktop and mobile src
                        productCardPicture.querySelectorAll('source').forEach((source, index) => {
                            switch (index) {
                                case 0:
                                    // Desktop Source
                                    source.media = newDesktopMedia;
                                    source.srcset = newDesktopSrcset;
                                    break;
                                case 1:
                                    // Mobile Source
                                    source.srcset = newMobileSrcset;
                                    break;
                                default:
                                    break;
                            }
                        });

                        // Update image src
                        productCardPictureImage.src = newImageSrc;
                        productCardPictureImage.srcset = newImageSrcset;
                    }
                }
            }

            // Update button state based on OOS
            const addToCartButton = productCard?.querySelector('[data-add-to-cart]');
            const addToCartButtonText = productCard?.querySelector('[data-add-to-cart-text]');
            if(addToCartButton && addToCartButtonText) {
                const productId = addToCartButton.getAttribute('data-product-id');
                const modalTarget = addToCartButton.getAttribute('data-modal-target');
                const isOutOfStock = swatchOption.getAttribute('data-variant-oos') === 'true';
                addToCartButton.disabled = isOutOfStock;
                let buttonText = window.translations.addToCart;
                if (isOutOfStock) {
                    buttonText = window.translations.soldOut;
                } else if (modalTarget === `add_to_cart-${productId}`) {
                    buttonText = window.translations.select;
                }
                addToCartButtonText.textContent = buttonText;
            }

            const originalCardPrice = productCard?.querySelector('.card__price--original');
            const cardPrice = originalCardPrice ?? productCard?.querySelector('.card__price');
            const price = swatchOption.getAttribute('data-variant-price');
            if(cardPrice && price) {
                cardPrice.textContent = formatMoney(price, theme.settingCurrencyFormat);
            }

            // Update the Add to Cart modal
            const modal = productCard?.querySelector('.modal--add-to-cart');
            if(modal) {
                const variantTitle = swatchOption.getAttribute('data-swatch');
                modal.updateModalForVariant(currentVariantId, variantTitle);
            }

            // Update the variant to add to cart
            if (inputVariantId != null && currentVariantId != null) {
                inputVariantId.value = currentVariantId;
            }
        }
    }
}

export default SwatchManager;

// Create an instance of the SwatchManager class
const swatchManager = new SwatchManager(swatchManagerConfig);

document.querySelectorAll(swatchManagerConfig.CARD_COLOR_OPTION).forEach((element) => {
    element.addEventListener('click', (element) => {
        element.stopPropagation();
        const selectedSwatchOption = element.currentTarget;
        swatchManager.changeSwatch(selectedSwatchOption, 'color');
    });
    element.addEventListener('keydown', (element) => {
        element.stopPropagation();
        if (element.key === 'Enter') {
            const selectedSwatchOption = element.currentTarget;
            swatchManager.changeSwatch(selectedSwatchOption, 'color');
        }
    });
});

document.querySelectorAll(swatchManagerConfig.CARD_TEXT_OPTION).forEach((element) => {
    element.addEventListener('click', (element) => {
        element.stopPropagation();
        const selectedTextOption = element.currentTarget;
        swatchManager.changeSwatch(selectedTextOption, 'text');
    });
});

document.querySelectorAll('.btn--add-to-cart').forEach((button) => {
    button.addEventListener('click', (e) => {
        e.preventDefault();
        const productId = button.getAttribute('data-product-id');
        const modal = document.querySelector(`#modal_add_to_cart-${productId}`);
        if (modal) {
            openModal(modal);
        }
    });
});


